export default class CrowdfundingIncentive {
    constructor(incentiveEl) {
        this.incentiveEl = incentiveEl;
        this.formEl = this.incentiveEl.closest('form');
        this.incentiveFieldElements = this.formEl.querySelectorAll('[data-incentive-field]');
        this.addressElement = this.formEl.querySelector('[data-incentive-address]');
        this.wantCheckbox = this.formEl.querySelector('[data-want-incentive]');

        this.radioBtns = this.incentiveEl.querySelectorAll('input[type="radio"]');
        this.radioBtns.forEach((radioBtn) => {
            radioBtn.addEventListener('change', this.checkIncentive.bind(this));
        });

        this.customChoiceBtn = this.incentiveEl.querySelector('[data-custom-choice]');
        this.customChoiceBtn.addEventListener('click', this.customAmount.bind(this));

        this.customAmountBtn = this.incentiveEl.querySelector('.custom-amount');
        this.customAmountBtn.addEventListener('keyup', this.checkIncentive.bind(this));

        this.formEl.querySelector('[data-want-incentive]').addEventListener('change', this.toggleIncentiveFields.bind(this));
    }

    customAmount(e) {
        this.incentiveEl.querySelector('[data-choice-self]').checked = true;
        this.checkIncentive();
    }

    checkIncentive() {
        console.log(this.incentiveEl.querySelector('input[type="radio"]:checked'));
        const selectedAmount = this.incentiveEl.querySelector('input[type="radio"]:checked').value;
        const incentiveAmount = this.incentiveEl.dataset.incentive;

        if (parseFloat(selectedAmount) >= parseFloat(incentiveAmount)) {
            this.incentiveFieldElements.forEach((incentiveFieldElement) => {
                incentiveFieldElement.style.display = 'block';
            });

            if (!this.wantCheckbox.checked) {
                this.formEl.querySelector('[data-incentive-address]').style.display = 'block';
            }
        } else {
            this.incentiveFieldElements.forEach((incentiveFieldElement) => {
                incentiveFieldElement.style.display = 'none';
            });
        }
    }

    toggleIncentiveFields(e) {
        if (e.target.checked) {
            this.addressElement.style.display = 'block';
        } else {
            this.addressElement.style.display = 'none';
        }
    }
}